/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 * S
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(function () {

  // trike inquiry
  $("#inquire-now").on("click", function () {
    $(".form-inquiry--popup-container").addClass("active");
    $(".form-inquiry--overlay").addClass("active");
  });

  $(".form-inqury--close-btn").on("click", function () {
    $(".form-inquiry--popup-container").removeClass("active");
    $(".form-inquiry--overlay").removeClass("active");
  });

  // upsell arrows
  $(".u__arrow").on("click", function () {
    $(".u__product-list").animate({ scrollLeft: "+=-300" }, 200);
  });

  $(".u__arrow--right").on("click", function () {
    $(".u__product-list").animate({ scrollLeft: "+=300" }, 200);
  });

  // add to cart
  $('.u__add-to-cart').on("click", function (){
    var item = $(this).attr('product-variant')
    addToCart(item)
  })

  // judge me button
  $('.jdgm-write-rev-link').addClass('button button--primary')

  function addToCart(item) {
    let formData = {
      'items': [{
        'id': item,
        'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async response => {

        const responseJson = await response.json();
        if (response.ok) {
          this.dispatchEvent(new CustomEvent("variant:added", {
            bubbles: true,
            detail: {
              variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
            }
          }));
          fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
            const cartContent = await response2.json();
            document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent
              }
            }));
            cartContent["sections"] = responseJson["sections"];
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true
            }));

            
            document.getElementById('mini-cart').open = true;

          });
        }
        this.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: response.ok ? "success" : "error",
            error: responseJson["description"] || ""
          }
        }));
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  // Transforming multi-line metafields to HTML
  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }
  document.querySelectorAll(".metafield").forEach(function (item) {
    item.innerHTML = htmlDecode(item.innerHTML);
  });
});

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// LBC Oct 2026 booking tracking fix: only pass real UTM values to Calendly (URL first, then cookie).
(function () {
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var q = new URLSearchParams(location.search);
  var ok = function (v) { return v && v !== 'undefined' && v !== 'null'; };
  document.querySelectorAll('.calendly-inline-widget').forEach(function (w) {
    try {
      var u = new URL(w.dataset.url);
      keys.forEach(function (k) {
        var v = q.get(k) || getCookie(k);
        if (ok(v)) u.searchParams.set(k, v); else u.searchParams.delete(k);
      });
      w.dataset.url = u.toString();
    } catch (e) {}
  });
})();

// LBC 11-01-2026: show the store number in the header so older riders can see it and dial it.
// The number is put together by script, so it is not plain text in the page source (Mickey's scraper rule).
// On phones the header shows a phone icon; tapping it calls the store.
(function () {
  function show() {
    var n = '6678866619'.split('').reverse().join('');
    var label = '(' + n.slice(0, 3) + ') ' + n.slice(3, 6) + '-' + n.slice(6);
    document.querySelectorAll('.header__icon-wrapper.contact').forEach(function (w) {
      w.classList.remove('hidden-phone');
      var s = w.querySelector('span');
      if (s) { s.textContent = label; s.classList.add('lbc-phone-label'); }
      var a = w.closest('a');
      if (a) { a.setAttribute('aria-label', 'Call the store ' + label); }
    });
    if (!document.getElementById('lbc-phone-css')) {
      var st = document.createElement('style');
      st.id = 'lbc-phone-css';
      st.textContent = '@media screen and (max-width: 740px){.lbc-phone-label{display:none}}';
      document.head.appendChild(st);
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', show); } else { show(); }
})();
(function () {
  if (document.getElementById('lbc-fix-css')) return;
  var st = document.createElement('style'); st.id = 'lbc-fix-css';
  st.textContent = '.shopify-section--gallery{overflow-x:clip}';
  (document.head || document.documentElement).appendChild(st);
})();
